// let baseParam = {appkey: "web-nwxHX2RAUMChnrah", "grant_type": "password", scope: "server"};
let baseParam = {
    appkey: "6E9A31EE4E0E4717B00EA1B3243B1A0C",
    grant_type: "password",
    scope: "server",
  };
  
  function setLKCookie(name, value) {
    //获取已有的cookie
    var cookies = document.cookie.split(';');
    var cookieObj = {};
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim().split('=');
      cookieObj[cookie[0]] = cookie[1];
    }
    
    //判断是否已有该cookie
    if (cookieObj.hasOwnProperty(name)) {
      //替换已有的cookie值
      cookieObj[name] = value;
    } else {
      //新增cookie
      cookieObj[name] = value;
    }
    
    //将cookie对象转换为字符串
    var cookieStr = '';
    for (var key in cookieObj) {
      if (cookieObj.hasOwnProperty(key)) {
        cookieStr += key + '=' + cookieObj[key] + ';';
      }
    }
    
    //设置cookie
    var expdate = new Date();
    expdate.setTime(expdate.getTime() + 24 * 3600000); //设置过期时间为24小时
    document.cookie = cookieStr + 'expires=' + expdate.toGMTString() + ';path=/';
  } 
  
  
  /**按ascii码从小到大排序
   *
   * @param obj
   * @returns {string}
   */
  function sort_ascii(obj) {
    let arr = new Array();
    let num = 0;
    for (let i in obj) {
      arr[num] = i;
      num++;
    }
    let sortArr = arr.sort();
    //let sortObj = {};    //完成排序值
    let str = ""; //自定义排序字符串
    for (let i in sortArr) {
      str += sortArr[i] + "=" + obj[sortArr[i]] + "&";
      //sortObj[sortArr[i]] = obj[sortArr[i]];
    }
    //去除两侧字符串
    let char = "&";
    str = str.replace(new RegExp("^\\" + char + "+|\\" + char + "+$", "g"), "");
  
    return str;
  }
  
  function getCookie(name) {
    let arr,
      reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if ((arr = document.cookie.match(reg))) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  }
  
  function delCookie(name) {
    let exp = new Date();
    exp.setTime(exp.getTime() - 1);
    let cval = getCookie(name);
    if (cval != null) {
      document.cookie =
        name +
        "=" +
        cval +
        ";expires=" +
        exp.toGMTString() +
        ";domain=localhost;path=/";
    }
  }
  
  function showTip(msg, duration, type, callback) {
    duration = isNaN(duration) ? 3000 : duration;
    let box = document.createElement("div");
    let container = document.createElement("div");
    let img = document.createElement("img");
    let text = document.createElement("div");
    box.className = "toast";
    container.className = "container-box";
    text.className = "text";
    text.innerHTML = msg;
    if (type === "error") {
      if (msg.length > 76) {
        img.src =
          "https://cdn.shopifycdn.net/s/files/1/0590/5789/7634/files/icon-error_2x_d5fd19bd-a8ca-450e-9115-d4aa5bf0e515.png?v=1648656070";
        text.style.cssText = "line-height:20px";
      } else {
        box.style.cssText = "width:40%";
        img.src =
          "https://cdn.shopifycdn.net/s/files/1/0590/5789/7634/files/icon-error.png?v=1648656070";
      }
    } else {img.src = "https://cdn.shopify.com/s/files/1/0590/5789/7634/files/icon-success.png?v=1740561972";
    }
    box.appendChild(container);
    container.appendChild(img);
    container.appendChild(text);
    document.body.appendChild(box);
    setTimeout(function () {
      let d = 0.5;
      box.style.webkitTransition =
        "-webkit-transform " + d + "s ease-in, opacity " + d + "s ease-in";
      box.style.opacity = "0";
      setTimeout(function () {
        document.body.removeChild(box);
        if (callback) {
          callback();
        }
      }, d * 1000);
    }, duration);
  }
  
  function showToast(msg, duration, callback) {
    duration = isNaN(duration) ? 3000 : duration;
    let m = document.createElement("div");
    m.innerHTML = msg;
    m.style.cssText =
      "width:40%; min-width:180px; background:#000; opacity:0.6; height:auto;min-height: 30px; color:#fff; line-height:30px; text-align:center; border-radius:4px; position:fixed; top:40%; left:40%; z-index:999999;";
    document.body.appendChild(m);
    setTimeout(function () {
      let d = 0.5;
      m.style.webkitTransition =
        "-webkit-transform " + d + "s ease-in, opacity " + d + "s ease-in";
      m.style.opacity = "0";
      setTimeout(function () {
        document.body.removeChild(m);
        if (callback) {
          callback();
        }
      }, d * 1000);
    }, duration);
  }
  
  function showToastCenter(msg, duration, callback) {
    duration = isNaN(duration) ? 3000 : duration;
    let m = document.createElement("div");
    m.innerHTML = msg;
    m.style.cssText =
      "width:40%; min-width:100px; background:#000; opacity:0.6; height:auto;min-height: 30px; color:#fff; line-height:30px; text-align:center; border-radius:4px; position:fixed; top:45%; left:30%; z-index:999999;";
    document.body.appendChild(m);
    setTimeout(function () {
      var d = 0.5;
      m.style.webkitTransition =
        "-webkit-transform " + d + "s ease-in, opacity " + d + "s ease-in";
      m.style.opacity = "0";
      setTimeout(function () {
        document.body.removeChild(m);
        if (callback) {
          callback();
        }
      }, d * 1000);
    }, duration);
  }
  
  function encrypt(str) {
    let key = CryptoJS.enc.Utf8.parse("thanks,lenkor123");
    let iv = CryptoJS.enc.Utf8.parse("thanks,lenkor123");
    let srcs = CryptoJS.enc.Utf8.parse(str);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding,
    });
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  }
  
  function sendRequest(
    uri,
    method,
    headers,
    param,
    successCallback,
    errorCallback
  ) {
    headers["clientType"] = 3;
    headers["languageId"] = 7;
    $.ajax({
      url: "https://official-web-api.topdon.com" + uri,
      type: method,
      contentType: "application/json;charset=utf-8",
      data: JSON.stringify(param),
      headers: headers,
      dataType: "json",
      success: function (data) {
        if (data.code === 2000) {
          successCallback(data.data||data);
        } else {
          if (errorCallback) {
            errorCallback(data);
          }
        }
      },
      error: function (data) {
        if (data.status === 401) {
          delCookie("access_token");
          let url = window.location.href;
          location.href = "/account/login?returnTo=" + url;
        } else {
          let json = data.responseJSON;
          errorCallback(json);
        }
      },
    });
  }
  
  function sendRequestWithQs(
    uri,
    method,
    headers,
    param,
    successCallback,
    errorCallback
  ) {
    headers["clientType"] = 3;
    headers["languageId"] = 7;
    $.ajax({
      url: "https://official-web-api.topdon.com" + uri,
      type: method,
      data: param,
      headers: headers,
      dataType: "json",
      success: function (data) {
        if (data.code === 2000) {
          successCallback(data);
        } else {
          showToast(data.msg, 3000);
          if (errorCallback) {
            errorCallback(data);
          }
        }
      },
      error: function (data) {
        if (data.status === 401) {
          let url = window.location.href;
          delCookie("access_token");
          location.href = "/account/login?returnTo=" + url;
        } else {
          let json = data.responseJSON;
          showToast(json.msg, 3000);
          errorCallback(json);
        }
      },
    });
  }
  
  function randomString(len) {
    len = len || 32;
    let $chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
    let maxPos = $chars.length;
    let pwd = "";
    for (let i = 0; i < len; i++) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  }
  
  function signin(param, successCallback, errorCallback) {
    postOwner(
      "/topdon_user/signin",
      param,
      function (data) {
        setLKCookie("access_token", data.tokenType + " " + data.accessToken);
        successCallback(data);
      },
      errorCallback
    );
  }
  
  function getSign(uri, param) {
    let timestamp = new Date().getTime();
    let nonceStr = randomString(10);
    let paramData = $.extend({}, baseParam, {
      nonceStr: nonceStr,
      timestamp: timestamp,
    });
    let signTemp = sort_ascii($.extend({}, param, paramData));
    let hash = CryptoJS.MD5(
      signTemp + "&appSecret=994EC72F491845A490CA84EE93A58D51"
    )
      .toString()
      .toUpperCase();
    return uri + "?" + signTemp + "&sign=" + hash;
  }
  
  function getWithSign(uri, headers, param, successCallback, errorCallback) {
    let accessToken = getCookie("access_token");
    let token = {
      Authorization: accessToken ? accessToken : "Basic bGVua29yOmxlbmtvcg==",
    };
    let url = getSign(uri, {});
    sendRequestWithQs(
      url,
      "GET",
      $.extend({}, headers, token),
      param,
      function (data) {
        successCallback(data.data);
      },
      errorCallback
    );
  }
  
  function postWithSign(uri, headers, param, successCallback, errorCallback) {
    let accessToken = getCookie("access_token");
    let token = {
      Authorization: accessToken ? accessToken : "Basic bGVua29yOmxlbmtvcg==",
    };
    let url = getSign(uri, {});
    sendRequest(
      url,
      "POST",
      $.extend({}, headers, token),
      param,
      successCallback,
      errorCallback
    );
  }
  
  function postWithSignQs(uri, headers, param, successCallback, errorCallback) {
    let accessToken = getCookie("access_token");
    let token = {
      Authorization: accessToken ? accessToken : "Basic bGVua29yOmxlbmtvcg==",
    };
    let url = getSign(uri, param);
    sendRequestWithQs(
      url,
      "POST",
      $.extend({}, headers, token),
      param,
      successCallback,
      errorCallback
    );
  }
  
  function get(uri, headers, param, successCallback, errorCallback) {
    sendRequest(uri, "GET", headers, param, successCallback, errorCallback);
  }
  
  function post(uri, headers, param, successCallback, errorCallback) {
    sendRequest(uri, "POST", headers, param, successCallback, errorCallback);
  }
  
  function getOwner(uri, param, successCallback, errorCallback) {
    sendRequestOwner(uri, "GET", {}, param, successCallback, errorCallback);
  }
  
  function postOwner(uri, param, successCallback, errorCallback) {
    sendRequestOwner(uri, "POST", {}, param, successCallback, errorCallback);
  }
  
  function sendRequestOwner(
    uri,
    method,
    headers,
    param,
    successCallback,
    errorCallback
  ) {
    headers["X-Requested-With"] = "Hiwie-Fetch";
    if (typeof param === "string") {
      headers["Content-Type"] = "application/json";
    }
    $.ajax({
      url: "https://official-web-api.topdon.com/api" + uri,
      type: method,
      data: param,
      headers: headers,
      dataType: "json",
      success: function (data) {
        if (data.success) {
          successCallback(data.success);
        } else {
          if (errorCallback) {
            errorCallback(data);
          }
        }
      },
      error: function (data) {
        if (data.status === 401) {
          let url = window.location.href;
          delCookie("access_token");
          location.href = "/account/login?returnTo=" + url;
        } else {
          let json = data.responseJSON;
          errorCallback(json);
        }
      },
    });
  }
  
  //以成员函数形式设置插件
  (function ($) {
    $.fn.extend({
      showLoading: function () {
        let html =
          "<div class='topdon-loading'><div class='loading-bg'><img src='https://cdn.shopifycdn.net/s/files/1/0590/5789/7634/files/loading.gif?v=1676657553'><span>Loading...</span></div></div>";
        if ($(".topdon-loading").length <= 0) {
          this.append(html);
        }
  
        return this; //为了支持链式操作 要返回当前对象
      },
      hideLoading: function () {
        $(".topdon-loading").remove();
        return this;
      },
      showButtonLoading() {
        this.attr("disabled", "disabled");
        this.html(
          "<img src='https://cdn.shopifycdn.net/s/files/1/0590/5789/7634/files/loading.gif?v=1676657553'>"
        );
      },
      hideButtonLoading(text) {
        this.removeAttr("disabled");
        this.html(text);
      },
    });
  })(jQuery);
  